import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OurServicesComponent implements OnInit, OnDestroy {
  featureTags = {};
  private destroy$ = new Subject<void>();
  constructor(private title: Title,
    private apiService: ApiService,
    public sharedDataService: SharedDataService
  ) { }

  ngOnInit(): void {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));

    if(!!this.featureTags && this.featureTags['sf_header_cart_count']){
      this.sharedDataService.cartResponse$.pipe(
        takeUntil(this.destroy$)
      ).subscribe(res => {        
        this.getCartCount();
      });      
    }
  }
  scrollTo(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  getCartCount() {
    if (this.apiService.loggedIn()) {
      this.sharedDataService.getOrderData();
    }
  }  

  ngOnDestroy(): void {    
    this.destroy$.next();
    this.destroy$.complete();
  }
}
